module.exports = __webpack_public_path__ + "img/sip.c4afa03a.svg";